<template>

  <BaseModal ref="baseModalRef" v-bind="childProps">
  
      <template v-slot:body>
        <div class="table-responsive table-list">
          <DataTable
            ref="dataTableRef"
            :value="state.gridRowData"
            paginator
            :rows="20"
            :rowsPerPageOptions="[10, 20, 50, 100, 200]"
          >
          <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>

            <!--데이터 매핑 컬럼-->
            <Column
              v-for="col of state.gridColumn"
              :key="col.field"
              :field="col.field"
              :header="col.header"
              :style="col.style"
            >

            <template #body="{ data, field }">
                <span :class="checkType(col,data)">{{data[field]}} </span>
            </template>
            
            </Column>
          </DataTable>
      </div>


      <div class="mb-3">
        <ElLabel name="파일 업로드"/>
          <ExcelManage
            class="form-control form-control-sm" 
            style="padding:0.25rem 0.5rem;" 
            v-show="true"
            ref="ModalExcelMngRef"
            :headerKeys="state.headerKeys"
            @return="r => getExcelData(r)"
          />
      </div>

      </template>
  </BaseModal>


</template>

<script setup>
import { reactive,onBeforeMount,ref } from 'vue';
import ExcelManage from '@/components/common/MCO_EX_001.vue';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import common from '@/js/common';
import BaseModal from '@/components/common/modal/BaseModal.vue';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { compList } from '@/api/comp';
import { getProdRevIdList, prodList} from '@/api/prod';
import { eventEdit } from '@/api/event';
const ModalExcelMngRef = ref()
const openModalBtnRef = ref()
const dataTableRef = ref()
const baseModalRef = ref()
const emits = defineEmits(['return'])
const props = defineProps({
    colDefs : Array,
    templateDataList : {
        type : Array,
        default : []
    },
    fileNm : String
})


onBeforeMount( async()=>{
  try{
    setIsLoading(true)
    state.gridColumn = props.colDefs.map((item)=>{
        state.headerKeys.push(item['field'])
        return item
    })
    let param = {
      page_count: 1,
      unit_count: 100000,
    }
    //회사이름이랑 매칭되는
    const cpRes = await compList(param)
    state.companyList = cpRes.rtnx

    const prodRevRes = await getProdRevIdList()
    state.revList = prodRevRes.rtn.map((item)=>{
      item = item.rev_id.replaceAll('PV','')
      return item
    });

    param = {
      rev_id : 'PV'+Math.max(...state.revList).toString(),
      enable_yn : 'Y'
    }

    const prodRes = await prodList(param)
    state.prodList = prodRes.rtn
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }

})



const state = reactive({
    gridColumn : [],
    headerKeys : [],
    gridRowData : [],
    selectRows : [],
    companyList : [],
    prodList : [],
    revList : [],
    file : null,
    saveDisabled : {
      typeCheck : false,
      nullCheck : false
    },
    incorrectCellCnt : 0,
    blank : ""
})

const childProps = ref({
  modalId : 'excelInsert',
  modalNm : '엑셀 일괄등록',
  size : 'lg',
  btnList : [
    {name : '템플릿 다운로드' , classNm:'modelFooterConfirm', function:downTemplate},
    {name : '확인' , classNm:'modelFooterConfirm', function:returnData},
  ]
})


function openModal(){
    baseModalRef.value.openModal()
}

// function closeModal(){
//     baseModalRef.value.closeModal()
// } 2024-09-02 alert띄우고 모달창 유지되게 요구사항 요청

function downTemplate(){
    let fileNm = props.fileNm
    let header = state.gridColumn
    let dataList = []
    if(props.templateDataList.length > 0){
        dataList = props.templateDataList
    }
    ModalExcelMngRef.value.excelDownload(fileNm,header,dataList)
}


function getExcelData(excelData){
  try{
    state.saveDisabled.nullCheck = false
    state.saveDisabled.typeCheck = false
    state.file = excelData.file
    //날짜 field 값 추출
    let dateKey = state.gridColumn.map((item)=>{
      if(item.type === 'date'){
        return item.field
      }
    }).filter((item2) => item2)

    const offset = 9*60*60 * 1000;
    state.gridRowData = excelData.sheets[0].map((item,index)=>{
      dateKey.forEach((field)=>{
        //엑셀 날짜 데이터들은 utc 기준이라 kst시간대로 +9시간 맞추기
        if(item[field] instanceof Date){
          item[field] = common.dateFormat(new Date(item[field].getTime() + offset))
        }
      })
      item.index = index
    
      state.selectRows.push(index)
      return item
    })
  }catch(e){
    console.log(e)
    alert('엑셀 읽는 과정중에 에러가 발생했습니다.')
  }
 
}


//부모창에 데이터 전달
async function returnData(){
  try{
    if(state.saveDisabled.typeCheck &&  state.saveDisabled.nullCheck) {
      alert('필수값 누락 및 데이터 형식에 맞지 않은 데이터가 있습니다.')
      return
    }

    if(state.saveDisabled.typeCheck) {
      alert('데이터 형식에 맞지 않은 데이터가 있습니다.')
      return
    }

    if(state.saveDisabled.nullCheck) {
      alert('필수값 누락 데이터가 있습니다.')
      return
    }


    
    let fileNm = location.pathname.split('/')[location.pathname.split('/').length-1].toUpperCase()
    let url = ''
    let cnt = 0
    switch(fileNm) {
      case 'MCP_CR_001':                              //회사 일괄
          url = '회사 다건(엑셀) 등록 api url'
          alert('회사 일괄 등록')
          break;

      case 'MCP_CL_002':                              //회사분류 일괄
          url = '회사분류 다건(엑셀) 등록 api url'
          alert('회사분류 일괄 등록')
          break;
          
      case 'MSH_SR_001':                              //담당자 일괄
          url = '담당자 다건(엑셀) 등록 api url'
          alert('담당자 일괄 등록')
          break;

      case 'MIM_CL_001':                              //상품분류체계 일괄
          url = '상품분류체계 다건(엑셀) 등록 api url'
          alert('상품분류체계 일괄 등록')
          break;

      case 'MSM_SA_007':                              //이벤트 일괄
          url = '이벤트 다건(엑셀) 등록 api url'
          for(let item of [...state.gridRowData]){
            let insertEvent = {...item}
            insertEvent.ev_seq = ''
            insertEvent.attachFileVO = {
              file_seq : '',
              file_div_id : '',
              del_file_seq : ''
            }
            insertEvent.tmp_yn = 'N'
            state.gridColumn.filter((col)=>col.type === 'date').forEach((col2)=>{
              insertEvent[col2.field] = insertEvent[col2.field].replaceAll('-','')
            })
            let res = await eventEdit(insertEvent)
            if(res.rtn?.ev_seq)cnt += 1
          }

          // alert('이벤트 일괄 등록')
          alert(`${state.gridRowData.length}중 ${cnt}건 등록되었습니다.`)

          break;
      case 'MSM_SA_009':                              //이벤트 일괄
          url = '이벤트 다건(엑셀) 등록 api url'
          for(let item of [...state.gridRowData]){
            let insertEvent = {...item}
            insertEvent.ev_seq = ''
            insertEvent.attachFileVO = {
              file_seq : '',
              file_div_id : '',
              del_file_seq : ''
            }
            insertEvent.tmp_yn = 'N'
            state.gridColumn.filter((col)=>col.type === 'date').forEach((col2)=>{
              insertEvent[col2.field] = insertEvent[col2.field].replaceAll('-','')
            })
            let res = await eventEdit(insertEvent)
            if(res.rtn?.ev_seq)cnt += 1
          }

          // alert('이벤트 일괄 등록')
          alert(`${state.gridRowData.length}중 ${cnt}건 등록되었습니다.`)

          break;
          
          
    }

  }catch(e){
    console.log(e)
  }
  // finally{ 2024-09-02 alert띄우고 모달창 유지되는 요구사항 요청
  //   closeModal()
  // }

}

//형식 유효성 체크
function checkType(col,data){
  try{
    let chngClass = false

    if(col.req && !data[col.field]){
      state.saveDisabled.nullCheck = true
      return 'text-b-rt'
    }

    if(data[col.field]){

      switch(col.type) {
        
          case 'spec':                              //특수문자 체크 타입
              if(common.checkSpecChar2(data[col.field])){
                chngClass = true
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'number':                              //숫자형 체크 타입
              if(!common.checkNumber(data[col.field])){
                chngClass = true
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'date':                              //날짜(일자) 체크 타입                                  
              if(!common.checkDateForm(data[col.field])){
                chngClass = true
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'phone':                              //휴대폰 번호 체크 타입
              if(!common.checkPhone(data[col.field])) {
                chngClass = !common.checkPhone(data[col.field])
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'telPhone':                              //유선전화 체크 타입
              if(!common.checkTelNumber(data[col.field])){
                chngClass = !common.checkTelNumber(data[col.field])
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'businessNo':                              //사업자번호 체크 타입
              if(!common.checkBizno(data[col.field])) {
                chngClass = !common.checkBizno(data[col.field])
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'email':                              //email 체크 타입
              if(!common.validateEmail(data[col.field])) {
                chngClass = !common.validateEmail(data[col.field])
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'yn':                              //email 체크 타입
              if(data[col.field] && data[col.field].toUpperCase() !== 'Y' && data[col.field].toUpperCase() !== 'N') {
                chngClass = true
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'cmpNm':                              //회사이름 체크 타입
              var check = true
              state.companyList.forEach((item)=>{
                if(item.cmp_nm === data[col.field]){
                  check = false
                }
              })
              if(check) {
                chngClass = true
                state.saveDisabled.typeCheck = true
              }
              break;
          case 'prodNm':     
              var check = true                         //상품이름 체크 타입
              state.prodList.forEach((item)=>{
                if(item.class_nm === data[col.field]){
                  check = false
                }
              })
              if(check) {
                chngClass = true
                state.saveDisabled.typeCheck = true
              }
              
              break;
      }
    }

    return chngClass ? 'text-b-rt' : ''
  }catch(e){
    alert('업로드중 에러가 발생했습니다.')
    console.log(e)
  }
  
}




defineExpose({
    openModal
})
</script>